import React from 'react'
import clsx from 'clsx'
import styles from './FieldBox.module.css'
import { BasicStyledComponent } from 'shared-definitions/types'

interface FieldBoxProps extends BasicStyledComponent {
  label: string
}

export const FieldBox: React.FC<React.PropsWithChildren<FieldBoxProps>> = ({
  className,
  label,
  children,
}) => (
  <label className={clsx(styles.container, className)}>
    <h4 className={styles.label}>{label}</h4>
    {children}
  </label>
)

export default FieldBox
